document.querySelectorAll('[style*="id:wpml-ls-submenu-"]').forEach((el) => {
    const match = el.getAttribute('style').match(/id:(wpml-ls-submenu-[^;]+)/);
    if (match) {
        el.id = match[1];
        el.style.removeProperty('id');
    }
});

(() => {
    const container = document.getElementById('site-navigation');
    if (!container) {
        return;
    }

    const button = document.getElementById('navbar-button');
    if (!button) {
        return;
    }

    const menu = container.getElementsByTagName('ul')[0];
    if (!menu) {
        button.style.display = 'none';
        return;
    }

    menu.setAttribute('aria-expanded', 'false');
    if (menu.className.indexOf('nav-menu') === -1) {
        menu.className += ' nav-menu';
    }

    const menuContainerInit = container.querySelector('.menuContainer');
    if (menuContainerInit) {
        menuContainerInit.inert = true;
    }

    button.addEventListener('click', () => {
        const menuRow = document.querySelector('.menuRow');
        if (menuRow) {
            menuRow.scrollTop = 0;
        }
        container.scrollTop = 0;
    });
})();

let savedScrollY = 0;

function preventTouch(e) {
    if (e.target.closest('.menuRow')) {
        return;
    }
    e.preventDefault();
}

function lhmToggleNavigation() {
    const siteNav = document.getElementById('site-navigation');
    const navbarButton = document.getElementById('navbar-button');
    const isOpen = siteNav && siteNav.classList.contains('toggled');

    if (document.body.classList.contains('lockScroll') || isOpen) {
        document.body.classList.remove('lockScroll');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overscrollBehavior = '';
        document.documentElement.style.overflow = '';
        document.documentElement.style.position = '';
        document.documentElement.style.width = '';
        document.removeEventListener('touchmove', preventTouch);
        window.scrollTo(0, savedScrollY);

        if (siteNav) {
            siteNav.classList.remove('toggled');
            siteNav.classList.add('untoggled');
        }

        if (navbarButton) {
            navbarButton.setAttribute('aria-expanded', 'false');
        }

        const menuContainerClose = document.querySelector('.menuContainer');
        if (menuContainerClose) {
            menuContainerClose.inert = true;
        }

        document.body.classList.remove('menuOpen');

        const menuToggler = document.querySelector('.menuToggler');
        if (menuToggler) {
            menuToggler.style.marginLeft = 'initial';
        }
    } else {
        savedScrollY = window.scrollY;

        if (siteNav) {
            siteNav.classList.add('toggled');
            siteNav.classList.remove('untoggled');
        }

        if (navbarButton) {
            navbarButton.setAttribute('aria-expanded', 'true');
        }

        const menuContainerOpen = document.querySelector('.menuContainer');
        if (menuContainerOpen) {
            menuContainerOpen.inert = false;
        }

        document.body.classList.add('menuOpen');
        document.body.classList.add('lockScroll');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${savedScrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overscrollBehavior = 'none';
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.position = 'fixed';
        document.documentElement.style.width = '100%';
        document.addEventListener('touchmove', preventTouch, { passive: false });
    }
}

window.lhmToggleNavigation = lhmToggleNavigation;

function lhmCloseAllSubmenus() {
    document.querySelectorAll('.menu-item-has-children').forEach((el) => {
        el.classList.remove('activeDropdown');
    });

    document.querySelectorAll('.submenuToggler').forEach((submenuToggler) => {
        submenuToggler.setAttribute('aria-expanded', 'false');
    });

    const mobileMenuHeading = document.querySelector('.mobileMenuHeading');
    if (mobileMenuHeading) {
        mobileMenuHeading.textContent = mobileMenuHeading.dataset.defaultText || '';
    }
}

window.lhmCloseAllSubmenus = lhmCloseAllSubmenus;

document.addEventListener('DOMContentLoaded', () => {
    const mobileMenuHeading = document.querySelector('.mobileMenuHeading');

    function resetMobileMenuHeading() {
        if (mobileMenuHeading) {
            mobileMenuHeading.textContent = mobileMenuHeading.dataset.defaultText || '';
        }
    }

    function setMobileMenuHeading(mainMenuItem) {
        if (!mobileMenuHeading) {
            return;
        }

        const titleEl = mainMenuItem.querySelector('.main-menu-link span');
        mobileMenuHeading.textContent = titleEl ? titleEl.textContent.trim() : (mobileMenuHeading.dataset.defaultText || '');
    }

    document.querySelectorAll('.navbar-toggler').forEach((toggler) => {
        toggler.addEventListener('click', () => {
            lhmToggleNavigation();
            lhmCloseAllSubmenus();
        });
    });

    const menuOverlay = document.querySelector('.menuOverlay');
    if (menuOverlay) {
        menuOverlay.addEventListener('click', () => {
            lhmToggleNavigation();
        });
    }

    document.querySelectorAll('.menu-item').forEach((menuItem) => {
        menuItem.addEventListener('click', () => {
            document.querySelectorAll('.menu-item-has-children').forEach((el) => {
                if (el !== menuItem) {
                    el.classList.remove('activeDropdown');
                }
            });
        });
    });

    document.querySelectorAll('.submenuToggler').forEach((toggler) => {
        toggler.addEventListener('click', (e) => {
            e.stopPropagation();

            const parent = toggler.parentElement;
            const grandParent = parent ? parent.parentElement : null;
            if (!grandParent) {
                return;
            }

            if (grandParent.classList.contains('activeDropdown')) {
                grandParent.classList.remove('activeDropdown');
                grandParent.classList.add('inActiveDropdown');
                toggler.setAttribute('aria-expanded', 'false');
                resetMobileMenuHeading();
            } else {
                grandParent.classList.add('activeDropdown');
                grandParent.classList.remove('inActiveDropdown');
                toggler.setAttribute('aria-expanded', 'true');
                setMobileMenuHeading(grandParent);
            }
        });
    });

    document.querySelectorAll('.subMenuBackButton').forEach((backButton) => {
        backButton.addEventListener('click', (e) => {
            e.stopPropagation();

            const mainMenuItem = backButton.closest('.main-menu-item');
            if (!mainMenuItem) {
                return;
            }

            mainMenuItem.classList.remove('activeDropdown');
            mainMenuItem.classList.add('inActiveDropdown');

            const toggler = mainMenuItem.querySelector('.submenuToggler');
            if (toggler) {
                toggler.setAttribute('aria-expanded', 'false');
            }

            resetMobileMenuHeading();
        });
    });
});

(() => {
    const menu = document.querySelector('#site-navigation');
    if (!menu) {
        return;
    }

    let lastHeight = window.innerHeight;
    let ticking = false;

    function resetFixedPosition() {
        menu.style.position = '';
        void menu.offsetHeight;
        menu.style.position = 'fixed';
        menu.style.top = '0';
        ticking = false;
    }

    window.addEventListener('resize', () => {
        if (window.innerHeight !== lastHeight) {
            lastHeight = window.innerHeight;
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(resetFixedPosition);
            }
        }
    });
})();
